import React, {useMemo} from "react"

import PropTypes from "prop-types"
import {Button as SemanticButton, Icon as SemanticIcon} from "semantic-ui-react"

import {getDataTestId} from "../../utils/stringUtil"

import "./buttonPrimary.scss"

const ButtonPrimary = ({
    actionType,
    children,
    className = null,
    dataTestId,
    disabled = false,
    height,
    icon,
    iconPosition = "left",
    loading = false,
    width,
    ...props
}) => {
    const style = useMemo(() => {
        let style = {}
        if (width) {
            style.width = width + "rem"
        }

        if (height) {
            style.height = height + "rem"
        }

        return style
    }, [height, width])

    return (
        <SemanticButton
            aria-busy={loading}
            aria-disabled={disabled}
            className={className}
            data-testid={dataTestId || getDataTestId(children, "bouton")}
            disabled={disabled || loading}
            loading={loading}
            primary
            style={style}
            type={actionType}
            {...props}
        >
            {icon && iconPosition === "left" && <SemanticIcon aria-hidden="true" className="left" name={icon} />}
            <div className="button-primary-children">{children}</div>
            {icon && iconPosition === "right" && <SemanticIcon aria-hidden="true" className="right" name={icon} />}
        </SemanticButton>
    )
}

ButtonPrimary.propTypes = {
    actionType: PropTypes.oneOf(["button", "reset", "submit"]),
    children: PropTypes.string.isRequired,
    className: PropTypes.string,
    dataTestId: PropTypes.string,
    disabled: PropTypes.bool,
    height: PropTypes.string,
    icon: PropTypes.string,
    iconPosition: PropTypes.oneOf(["left", "right"]),
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    width: PropTypes.string,
}

export default ButtonPrimary
